import defaultItems from '../../../../../common/defaultItems';

export default function () {
    return {
        index: '',
        type: 'STATIC_BLOCK',
        title: 'Image Paragraph',
        thumbnailUrl: null,
        content: {
            columnNum: 2,
            backgroundColor: '#ffffff',
            wrapperBackgroundColor: '#ffffff',
            paddingTop: 20,
            paddingBottom: 20,
            structureLocked: false,
            columns: [
                {
                    columnIdx: '',
                    size: 1 / 2,
                    columnItems: [
                        {
                            elmIdx: '',
                            type: 'IMAGE',
                            content: {
                                ...defaultItems.IMAGE.content,
                            },
                        },
                    ],
                },
                {
                    columnIdx: '',
                    size: 1 / 2,
                    columnItems: [
                        {
                            elmIdx: '',
                            type: 'PARAGRAPH',
                            content: {
                                ...defaultItems.PARAGRAPH.content,
                                textMarkupValue: '<h3>Interesting topic #1</h3>',
                            },
                        },
                        {
                            elmIdx: '',
                            type: 'PARAGRAPH',
                            content: {
                                ...defaultItems.PARAGRAPH.content,
                                textMarkupValue:
                                    '<p><strong>Tip:</strong> Give your sentences room to breathe; heck, give them their own darn paragraph, if you must.</p>',
                                paddingTop: 0,
                            },
                        },
                    ],
                },
            ],
        },
    };
}
